module.exports = __webpack_public_path__ + "static/media/trailer.badd2902.svg";